export function accessory(id, label, price) {
    const priceLabel = String((price.amount / 100).toFixed(2));
    return { _type: "accessory", id, label, price, priceLabel };
}
